//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ConfirmacionSuscripcion",
  head() {
    return {
      title: 'Gracias por suscribirte',
      meta: [
        { hid: 'description', name: 'description', content: '' },
        { hid: 'keywords', name: 'keywords', content: '' },
        { hid: 'og:image', property: 'og:image', content: require('~/assets/img/abstracta-academy-meta-data.jpg') },
      ]
    }
  },
};
